module.exports = {
    INACTIVE_STATUS_LIST: ['CANCELADO', 'BAJA', 'BLOQUEADO', 'BLOQUEADO Y CAN'],
    CANCELLED_STATUS: 'CANCELADO',
    BLOCKED_STATUS: 'BLOQUEADO',
    EV_STATUS: 'EN VIGOR',
};
